import { render, staticRenderFns } from "./ClosedPage.vue?vue&type=template&id=14f8efc8&scoped=true&"
import script from "./ClosedPage.vue?vue&type=script&lang=js&"
export * from "./ClosedPage.vue?vue&type=script&lang=js&"
import style0 from "./ClosedPage.vue?vue&type=style&index=0&id=14f8efc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f8efc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
